/* ======================== */
// Layout Types
/* ======================== */
export const LayoutTypes = {
    GRID: 'grid',
    LAYERED: 'layered'
};
/* ======================== */
// Alignment Types
/* ======================== */
export const AlignmentTypes = {
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top',
    BOTTOM: 'bottom'
};
/* ======================== */
// Sidebar Types
/* ======================== */
export const NavigationTypes = {
    INLINE: 'inline',
    LAYERED: 'layered'
};
/* ======================== */
// Menu Types
/* ======================== */
export const MenuTypes = {
    TAB: 'tab',
    LIST: 'list',
    TIMELINE: 'timeline'
};
/* ======================== */
// Page Types
/* ======================== */
export const PageTypes = {
    STATIC: 'static',
    STORY: 'story'
};
/* ======================== */
// Dataset Types
/* ======================== */
export const DatasetTypes = {
    API: 'api',
    FILE: 'file',
    JSON: 'json',
    GEO: 'geo'
};
export const GeoTypes = {

};
/* ======================== */
// Visualisation Types
/* ======================== */
export const VisEngineTypes = {
    MAPBOX: 'mapbox',
    DECKGL: 'deckgl',
    NIVO: 'nivo',
    AMCHARTS: 'amcharts'
};
export const LayerTypes = {
    deckgl: {
        layers: [
            // Core Layers
            'ArcLayer',
            'BitmapLayer',
            'ColumnLayer',
            'GeoJsonLayer',
            'GridCellLayer',
            'IconLayer',
            'LineLayer',
            'PathLayer',
            'PointCloudLayer',
            'PolygonLayer',
            'ScatterplotLayer',
            'SolidPolygonLayer',
            'TextLayer'
        ],
        aggregationLayers: [
            // Aggregation Layers
            'ContourLayer',
            'GridLayer',
            'GPUGridLayer',
            'CPUGridLayer',
            'HexagonLayer',
            'ScreenGridLayer',
            'HeatmapLayer'
        ],
        geoLayers: [
            // Geo Layers
            'GreatCircleLayer',
            'H3ClusterLayer',
            'H3HexagonLayer',
            'S2Layer',
            'TileLayer',
            'TripsLayer',
            'TerrainLayer',
            'MVTLayer'
        ],
        custom: [
            'IconClusterLayer'
        ]
        /*layers: {
            // Core Layers
            ArcLayer: 'ArcLayer',
            BitmapLayer: 'BitmapLayer',
            ColumnLayer: 'ColumnLayer',
            GeoJsonLayer: 'GeoJsonLayer',
            GridCellLayer: 'GridCellLayer',
            IconLayer: 'IconLayer',
            LineLayer: 'LineLayer',
            PathLayer: 'PathLayer',
            PointCloudLayer: 'PointCloudLayer',
            PolygonLayer: 'PolygonLayer',
            ScatterplotLayer: 'ScatterplotLayer',
            SolidPolygonLayer: 'SolidPolygonLayer',
            TextLayer: 'TextLayer'
        },
        aggregationLayers: {
            // Aggregation Layers
            ContourLayer: 'ContourLayer',
            GridLayer: 'GridLayer',
            GPUGridLayer: 'GPUGridLayer',
            CPUGridLayer: 'CPUGridLayer',
            HexagonLayer: 'HexagonLayer',
            ScreenGridLayer: 'ScreenGridLayer',
            HeatmapLayer: 'HeatmapLayer',
        },
        geoLayers: {
            // Geo Layers
            GreatCircleLayer: 'GreatCircleLayer',
            H3ClusterLayer: 'H3ClusterLayer',
            H3HexagonLayer: 'H3HexagonLayer',
            S2Layer: 'S2Layer',
            TileLayer: 'TileLayer',
            TripsLayer: 'TripsLayer',
            TerrainLayer: 'TerrainLayer',
            MVTLayer: 'MVTLayer'
        },
        custom: {
            IconClusterLayer: 'IconClusterLayer'
        }*/
    },
}
export const ChartTypes = {
    BAR: 'bar',
    PIE: 'pie',
    LINE: 'line',
    AREA: 'area',
    RADAR: 'radar'
};
/* ======================== */
// Data Loading Types
/* ======================== */
export const LoadingTypes = {
    BULK: 'init',
    SEQUENTIAL: 'sequential',
    ACTIVE: 'active'
};
export const PolygonLayer = {
    'type': 'polygonLayer',
    'requiredColumns': ['geojson'],
    'attributes': ['color', 'opacity', 'extruded']
};
export const LineLayer = {
    'type': 'lineLayer',
    'requiredColumns': ['lat0','lng0','lat1','lng1'],
    'attributes': ['color', 'opacity', 'strokewidth']
};
export const PointLayer = {
    'type': 'lineLayer',
    'requiredColumns': ['lat','lng'],
    'optionalColumns': ['altitude'],
    'attributes': ['color', 'opacity', 'radius']
};
export const ImageLayer = {
    'type': 'imageLayer',
    'requiredColumns': ['lat','lng','icon'],
    'attributes': ['size']
};
export const VisualisationTypes = [
    PolygonLayer,
    LineLayer,
    PointLayer,
    ImageLayer
];
/*
interface Config {

}*/